/* eslint-disable max-len */
import React from 'react';
import { type Argument, cs } from '@bbkAdminUtils/css-utils';
import type { ReactFCC } from '@bbkAdminUtils/utility-types';
import logo from '@bbkAdminImages/cbretention-logo.png';
import whiteLogo from '@bbkAdminImages/cbretention-white-logo.png';
import cbGrowthLogo from '@bbkAdminImages/growth-logo.png';

export const CBRetentionLogo: ReactFCC<{
  white?: boolean;
  className?: Argument;
}> = ({ white, className }) => (
  <img
    srcSet={`${white ? whiteLogo : logo} 2x`}
    className={cs(className ?? 'tw-w-full')}
    alt="Chargebee Retention"
  />
);

export const CBGrowthLogo: React.FC = () => (
  <img
    srcSet={`${cbGrowthLogo}`}
    className="tw-w-full"
    alt="Chargebee Growth"
  />
);

export const CBGrowthLogoSVG = (
  <svg
    width="104"
    height="25"
    viewBox="0 0 104 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.955 12.135 24 8.315V0h-8.315zM0 12c0 .989.112 1.955.36 2.876l7.595-2.741L.292 9.37C.112 10.225 0 11.1 0 12m2.832-7.753 5.123 7.888L10.315.112a12 12 0 0 0-7.483 4.135m5.123 7.888L24 15.955v8.337h-8.315z"
      fill="#f30"
    />
    <path
      d="m2.832 20.022 5.123-7.887 2.36 12.022c-2.99-.404-5.618-1.932-7.483-4.135"
      fill="#f30"
    />
    <path
      d="M41.238 21.998q-.702 0-1.44-.054-.72-.054-1.35-.144v-2.088q.648.072 1.386.126.738.072 1.386.072 1.206 0 1.944-.288.756-.288 1.098-.918.36-.612.36-1.566v-1.926l.54-1.224q-.054 1.35-.558 2.304a3.6 3.6 0 0 1-1.368 1.44q-.864.486-1.998.486a4.4 4.4 0 0 1-1.836-.378 4.3 4.3 0 0 1-1.404-1.044 4.9 4.9 0 0 1-.9-1.566 5.6 5.6 0 0 1-.324-1.926v-.378q0-1.026.324-1.908.342-.9.954-1.566a4.2 4.2 0 0 1 1.458-1.026 4.7 4.7 0 0 1 1.872-.36q1.206 0 2.088.522.9.522 1.404 1.512t.558 2.43l-.432.072v-4.23h1.98v8.622q0 1.782-.612 2.88t-1.89 1.602q-1.26.522-3.24.522m.72-5.922q.72 0 1.314-.324t.954-.936.36-1.476v-.63q0-.828-.378-1.404a2.3 2.3 0 0 0-.954-.864 2.8 2.8 0 0 0-1.296-.306q-.792 0-1.404.378-.594.36-.936 1.026t-.342 1.584q0 .9.342 1.566t.936 1.026q.612.36 1.404.36m7.751 2.07V8.372h1.98v4.14h-.054q0-2.106.9-3.186t2.646-1.08h.36v2.178h-.684q-1.26 0-1.962.684-.684.666-.684 1.944v5.094zm12.134.342q-1.296 0-2.286-.414a5 5 0 0 1-1.674-1.116 5.1 5.1 0 0 1-1.044-1.62 5.2 5.2 0 0 1-.342-1.872v-.378q0-1.008.36-1.908a5.1 5.1 0 0 1 1.062-1.62 4.8 4.8 0 0 1 1.692-1.116q.99-.414 2.232-.414t2.232.414a4.7 4.7 0 0 1 1.674 1.116 4.7 4.7 0 0 1 1.062 1.62q.36.9.36 1.908v.378q0 .972-.36 1.872a4.8 4.8 0 0 1-1.026 1.62 5 5 0 0 1-1.674 1.116q-.99.414-2.268.414m0-2.142q.918 0 1.548-.396.63-.414.954-1.098.324-.702.324-1.584 0-.9-.342-1.584a2.47 2.47 0 0 0-.972-1.098q-.63-.414-1.512-.414t-1.53.414q-.63.396-.972 1.098-.342.684-.342 1.584 0 .882.324 1.584.342.684.972 1.098.63.396 1.548.396m10.656 1.8 1.854-9.45h2.88l2.141 9.45h-1.98L75.217 8.75h1.044l-1.925 9.396zm-.739 0-.017-2.052h1.998v2.052zm-1.008 0L68.09 8.372h2.43l2.537 9.774zm7.273 0v-2.052h1.997l-.018 2.052zm.791 0 2.25-9.774h2.269l-2.358 9.774zm10.913.126q-1.35 0-2.232-.342a2.5 2.5 0 0 1-1.296-1.188q-.432-.846-.432-2.268l.018-8.856h2.34l-.018 9.018q0 .72.378 1.116.396.378 1.116.378h1.53v2.142zm-5.508-8.064V8.372h6.912v1.836zm9.011 7.938V5.006h2.502v7.668h-.431q0-1.476.377-2.502.378-1.026 1.116-1.566.756-.54 1.908-.54h.109q1.673 0 2.538 1.152t.864 3.348v5.58h-2.502v-5.814q0-.936-.54-1.476-.523-.54-1.386-.54-.918 0-1.495.612-.557.594-.558 1.566v5.652z"
      fill="#111827"
    />
  </svg>
);
